<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <DataTable
          :value="items"
          :paginator="showPagination"
          class="p-datatable-outlets"
          :rows="limit"
          :lazy="true"
          data-key="doc_number"
          :filters="filters1"
          :loading="loading1"
          :totalRecords="total_records"
          @page="getListOutletInbounds($event)"
        >
          <h5>
            <b>Daftar Penerimaan Barang</b>
          </h5>
          <template #header>
            <div class="table-header">
              <div class="p-grid">
                <!-- First Line: Search Filters -->
                <div class="p-col-12">
                  <div class="p-d-flex p-jc-start p-ai-center">
                    <span class="p-input-icon-left p-mr-2">
                      <i class="pi pi-search" />
                      <InputText
                        v-model="filters1['doc_number']"
                        placeholder="Cari Nomor Bon"
                        @keyup.enter="getListOutletInbounds()"
                      />
                    </span>
                    <span class="p-input-icon-left p-mr-2">
                      <Calendar
                        v-model="filters1['doc_date']"
                        placeholder="Cari Tanggal Bon"
                        style="width: 250px"
                        :showIcon="true"
                        dateFormat="yy-mm-dd"
                        :selectOtherMonths="true"
                        :showButtonBar="true"
                        @keyup.enter="getListOutletInbounds()"
                      />
                    </span>
                    <Dropdown
                      v-model="filters1['status']"
                      :options="statusOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Status"
                      :showClear="true"
                      class="p-mr-2"
                      style="width: 200px"
                    />
                    <Button
                      label="Cari"
                      class="p-button-info"
                      @click="getListOutletInbounds()"
                    />
                    <Button
                      label="Reset"
                      icon="pi pi-refresh"
                      class="p-button-secondary p-ml-2"
                      @click="resetFilters()"
                    />
                  </div>
                </div>

                <!-- Second Line: Import Buttons -->
                <div class="p-col-12">
                  <div class="p-d-flex p-jc-start p-ai-center">
                    <div v-if="loading.upload == false">
                      <FileUpload
                        @uploader="onUpload"
                        :customUpload="true"
                        mode="basic"
                        :disabled="loading.upload"
                        accept=".csv"
                        label="Import"
                        chooseLabel="Import"
                        class="p-mr-2 p-d-inline-block"
                      />
                      <FileUpload
                        @uploader="onUploadSisgud"
                        :customUpload="true"
                        mode="basic"
                        :disabled="loading.upload"
                        accept=".csv"
                        label="Sisgud"
                        chooseLabel="Import Sisgud"
                        class="p-mr-2 p-d-inline-block"
                      />
                    </div>
                    <div v-if="loading.upload == true">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        :disabled="true"
                      >
                        Uploading...
                        <span>
                          <i
                            class="pi pi-spin pi-spinner"
                            style="font-size: 12px"
                          ></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #empty>Data tidak tersedia.</template>
          <template #loading>Sedang mengambil data. Mohon tunggu.</template>
          <Column field="doc_number" header="Nomor Bon">
            <template #body="slotProps">
              {{ slotProps.data.doc_number }}
            </template>
          </Column>
          <Column field="doc_date" header="Tanggal Bon">
            <template #body="slotProps">
              <span>
                {{ slotProps.data.doc_date }}
              </span>
            </template>
          </Column>

          <Column header="Total Barang">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_item }}</span>
            </template>
          </Column>
          <Column header="Total Qty">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_qty }}</span>
            </template>
          </Column>
          <Column header="Total Harga">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_price | currency }}</span>
            </template>
          </Column>
          <Column header="Status">
            <template #body="slotProps">
              <div v-if="slotProps.data.status == 1">
                <span style="color: green; font-weight: bold">Confirmed</span>
              </div>
              <div v-else-if="slotProps.data.status == 2">
                <span style="color: blue; font-weight: bold">Rejected</span>
              </div>
              <div v-else>
                <span style="color: red; font-weight: bold">Pending</span>
              </div>
            </template>
          </Column>
          <Column
            headerStyle="width: 12rem"
            bodyStyle="text-align: center; overflow: visible"
          >
            <template #body="slotProps">
              <div>
                <router-link
                  :to="{
                    name: 'receiving-detail',
                    query: { doc_number: slotProps.data.doc_number }
                  }"
                >
                  <Button
                    type="button"
                    icon="pi pi-eye"
                    class="p-button-rounded p-mr-2"
                  ></Button>
                </router-link>
                <Button
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDelete(slotProps.data)"
                  v-if="
                    slotProps.data.status === 0 && user.role == 'OUTLET_MANAGER'
                  "
                ></Button>
              </div>
            </template>
          </Column>
        </DataTable>

        <Dialog
          :visible.sync="deleteDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="outletInbound">
              Apakah kamu yakin ingin menghapus
              <b>{{ outletInbound.doc_number }}</b
              >?
            </span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteOutletInbound(outletInbound.doc_number)"
            />
          </template>
        </Dialog>
        <Dialog
          :visible.sync="activeDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="outletInbound">
              Apakah kamu yakin ingin meng-aktifkan
              <b>{{ outletInbound.doc_number }}</b
              >?
            </span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="activeDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="activeOutletInbound(outletInbound.doc_number)"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const moment = require('moment')
export default {
  data() {
    return {
      moment: moment,
      filters1: {
        doc_date: '',
        doc_number: '',
        status: null
      },
      statusOptions: [
        { label: 'Pending', value: 0 },
        { label: 'Confirmed', value: 1 },
        { label: 'Rejected', value: 2 }
      ],
      doc_number: '',
      loading1: true,
      items: null,
      deleteDialog: false,
      activeDialog: false,
      outletInbound: {},
      total_records: 0,
      limit: 10,
      loading: {
        deleteButton: false,
        activeButton: false,
        upload: false
      }
    }
  },
  computed: {
    ...mapState(['user', 'isAuthenticated']),
    showPagination() {
      return this.total_records > this.limit
    }
  },

  mounted() {
    this.getListOutletInbounds()
  },
  methods: {
    async onUpload(event) {
      this.loading.upload = true
      const formData = new FormData()
      formData.set('file', event.files[0])

      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/csv`,
          formData
        )

        if (response.status === 200) {
          this.doc_number = response.data.data.doc_number
          this.showToast('success', 'Success', 'File Uploaded')
          this.loading.upload = false

          // Navigate immediately on success
          this.$router.push({
            name: 'receiving-detail',
            query: { doc_number: this.doc_number }
          })
        } else {
          this.loading.upload = false
          this.showToast('error', 'Failed', 'File Upload Failed')
        }
      } catch (error) {
        console.error('Error uploading file:', error)
        this.loading.upload = false
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Error uploading file'
        this.showToast('error', 'Failed', errorMessage)
      }
    },

    async onUploadSisgud(event) {
      this.loading.upload = true
      let formData = new FormData()
      formData.set('file', event.files[0])

      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/csv/sisgud`,
          formData
        )

        if (response.status === 200) {
          this.doc_number = response.data.data.doc_number
          this.showToast('success', 'Success', 'File Uploaded')
          this.loading.upload = false

          // Navigate immediately on success
          this.$router.push({
            name: 'receiving-detail',
            query: { doc_number: this.doc_number }
          })
        } else {
          this.loading.upload = false
          this.showToast('error', 'Failed', 'File Upload Failed')
        }
      } catch (error) {
        console.error('Error uploading file:', error)
        this.loading.upload = false
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Error uploading file'
        this.showToast('error', 'Failed', errorMessage)
      }
    },

    async getListOutletInbounds(event) {
      // Calculate offset from pagination event
      let offset = 0
      if (event) {
        offset = event.first || event.page * this.limit
      }

      this.loading1 = true

      try {
        // Build query parameters using URLSearchParams
        const params = new URLSearchParams({
          order_by: '-doc_date',
          offset: offset.toString(),
          limit: this.limit.toString()
        })

        // Add filters if they exist
        if (this.filters1.doc_number) {
          params.append('doc_number', this.filters1.doc_number)
        }

        if (this.filters1.doc_date) {
          // Format date without mutating the filter state
          const formattedDate = moment(this.filters1.doc_date).format(
            'YYYY-MM-DD'
          )
          params.append('doc_date', formattedDate)
        }

        if (this.filters1.status != null) {
          params.append('status', this.filters1.status.toString())
        }

        const url = `${
          process.env.VUE_APP_API_URL
        }/dashboard/outlet-inbounds?${params.toString()}`
        const response = await this.$http.get(url)

        if (response.status === 200) {
          this.items = response.data.data.outlet_inbounds
          this.total_records = response.data.data.total_item
        } else {
          console.error('Gagal mendapatkan outlet inbounds')
          this.showToast(
            'error',
            'Error',
            'Gagal mengambil data penerimaan barang'
          )
        }
      } catch (error) {
        console.error(
          'Terjadi kesalahan saat mengambil data outlet inbounds:',
          error
        )
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Gagal mengambil data penerimaan barang'
        this.showToast('error', 'Error', errorMessage)
      } finally {
        this.loading1 = false
      }
    },

    resetFilters() {
      this.filters1 = {
        doc_date: '',
        doc_number: '',
        status: null
      }
      this.getListOutletInbounds()
    },

    confirmDelete(outletInbound) {
      this.outletInbound = outletInbound
      this.deleteDialog = true
    },

    confirmActive(outletInbound) {
      this.outletInbound = outletInbound
      this.activeDialog = true
    },

    async deleteOutletInbound(doc_number) {
      this.loading.deleteButton = true

      try {
        const response = await this.$http.delete(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds?doc_number=${doc_number}`
        )

        if (response.status === 200) {
          this.showToast('success', 'Delete Success', 'Data Deleted')
          await this.getListOutletInbounds()
        } else if (response.status === 403) {
          this.showToast(
            'error',
            'Delete Not Permitted',
            `Data Can't be Deleted`
          )
        } else {
          this.showToast('error', 'Delete Failed', 'Data failed to Deleted')
          console.error('gagal delete')
        }
      } catch (error) {
        console.error('Error deleting outlet inbound:', error)
        this.showToast('error', 'Delete Failed', 'An error occurred')
      } finally {
        this.loading.deleteButton = false
        this.deleteDialog = false
      }
    },

    async activeOutletInbound(doc_number) {
      this.loading.activeButton = true

      try {
        const response = await this.$http.patch(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds?doc_number=${doc_number}`
        )

        this.activeDialog = false

        if (response.status === 200) {
          this.showToast(
            'success',
            'Change status success',
            'Congrats, those status has been changed'
          )
          await this.getListOutletInbounds()
        } else {
          this.showToast('error', 'Change status failed', 'Please try again')
          console.error('gagal merubah status')
        }
      } catch (error) {
        this.showToast('error', 'Change status failed', 'Please try again')
        console.error('Error changing status:', error)
      } finally {
        this.loading.activeButton = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
